import { render, staticRenderFns } from "./ErrorPage404.vue?vue&type=template&id=4c115c4c&scoped=true"
import script from "./ErrorPage404.vue?vue&type=script&lang=js"
export * from "./ErrorPage404.vue?vue&type=script&lang=js"
import style0 from "./ErrorPage404.vue?vue&type=style&index=0&id=4c115c4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c115c4c",
  null
  
)

export default component.exports